import InputField from '@/features/ui/inputs/components/InputField'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface NoteInputProps {
    note: string
    onChange: (note: string) => void
}

const NoteInput: FC<NoteInputProps> = ({ note, onChange }) => {
    const { t } = useTranslation()

    return (
        <InputField
            autoFocus
            multiline
            placeholder={t('common.insertNoteFormContent.inputPlaceholder')}
            value={note}
            onChange={onChange}
            inputStyle={{ height: 130 }}
            style={{ width: '100%' }}
        />
    )
}

export default NoteInput
